import ByBank from './ByBank';
import ByCard from './ByCard';
import ByPayeer from './ByPayeer';
import ByUtex from './ByUtex';
import ByUTT from './ByUTT';
import ByAdvCash from './ByAdvCash';

export const plugins = [ByBank, ByCard, ByPayeer, ByUtex, ByUTT, ByAdvCash];
